import { motion } from "framer-motion";
import { Gift, Scissors } from "lucide-react";
import { openLoyalty } from "../lib/format";

const ITEMS = ["Tessera fedeltà BANY", "10 tagli = 50% di sconto sul successivo", "Lascia la tua email e ricevi la tessera"];

const LoyaltyBanner = () => (
  <section data-testid="loyalty-banner" className="relative overflow-hidden bg-[#071528] text-[#F7F2EC] border-y border-[#F7F2EC]/10">
    <button onClick={openLoyalty} data-testid="loyalty-banner-button" className="relative block w-full text-left">
      <div className="flex items-center gap-10 py-3 whitespace-nowrap">
        <motion.div className="flex items-center gap-10 shrink-0" animate={{ x: ["0%", "-50%"] }} transition={{ duration: 28, repeat: Infinity, ease: "linear" }}>
          {[...ITEMS, ...ITEMS, ...ITEMS, ...ITEMS].map((t, i) => (
            <span key={i} className="flex items-center gap-10 font-mono-alt text-[11px] sm:text-xs uppercase tracking-[0.3em]">
              <Scissors className="w-3.5 h-3.5 opacity-70" />
              {t}
            </span>
          ))}
        </motion.div>
      </div>
    </button>
  </section>
);

export const LoyaltyCard = () => (
  <motion.a
    href="#tessera"
    onClick={openLoyalty}
    data-testid="loyalty-card"
    initial={{ opacity: 0, y: 16 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.2 }}
    transition={{ duration: 0.6 }}
    className="group relative flex flex-col sm:flex-row sm:items-center gap-6 overflow-hidden rounded-2xl bg-[#0B1F3A] text-[#F7F2EC] p-6 sm:p-8 mb-10 noise-overlay"
  >
    <div className="relative z-10 flex-1">
      <p className="font-mono-alt text-[11px] uppercase tracking-[0.3em] text-[#F7F2EC]/60 mb-3">Tessera fedeltà</p>
      <h3 className="font-display text-2xl sm:text-3xl font-bold tracking-tight mb-2">10 tagli, poi il 50% di sconto</h3>
      <p className="text-sm text-[#F7F2EC]/70 max-w-md">Lascia la tua email: ti mandiamo la tessera BANY con il QR. A ogni taglio la scansioniamo in negozio.</p>
    </div>
    <span className="relative z-10 inline-flex items-center gap-2 self-start sm:self-auto rounded-full bg-[#F7F2EC] text-[#0B1F3A] px-5 py-3 text-xs font-bold uppercase tracking-[0.15em] group-hover:-translate-y-0.5 transition-transform duration-300">
      <Gift className="w-4 h-4" /> Ricevi la tessera
    </span>
  </motion.a>
);

export default LoyaltyBanner;
